module.exports = __webpack_public_path__ + "static/media/chorinitia.dd525b25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginPage/internalComponents/chorinitia.svg
// module id = 151
// module chunks = 0